import React from "react";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import {
  BasicDialogFrame,
  BASIC_DIALOG_ACTION_CLASS,
  BASIC_DIALOG_SECONDARY_ACTION_CLASS,
} from "@/components/ui/BasicDialog.jsx";
import { cn } from "@/utils/cn";

function formatWelcomeName({ salutation, lastName, name, fallbackName }) {
  const resolvedLastName = String(lastName || "").trim() ||
    String(name || "").trim().split(/\s+/).filter(Boolean).at(-1) ||
    String(fallbackName || "there").trim();
  const resolvedSalutation = String(salutation || "").trim();
  return [resolvedSalutation, resolvedLastName].filter(Boolean).join(" ");
}

export default function SettingsWelcome({
  open = false,
  name = "",
  salutation = "",
  lastName = "",
  onClose = () => {},
}) {
  const { t } = useLanguage();
  if (!open) return null;

  const welcomeName = formatWelcomeName({
    salutation,
    lastName,
    name,
    fallbackName: t("settings.welcome.fallbackName", "there"),
  });
  const titleLineOne = t("settings.welcome.titleLineOne", "Welcome to your Settings,");
  const titleLineTwo = t("settings.welcome.titleLineTwo", "{name}", {
    name: welcomeName,
  });

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/35" aria-hidden="true" />
      <BasicDialogFrame
        role="dialog"
        aria-modal="true"
        aria-labelledby="patient-settings-welcome-title"
        iconSrc="/afrimed_elephant_icon.svg"
        iconAlt="AfriMed"
        titleId="patient-settings-welcome-title"
        title={
          <>
            <span className="block">{titleLineOne}</span>
            <span className="block">{titleLineTwo}</span>
          </>
        }
        body={t(
          "settings.welcome.patientBody",
          "Settings is your control centre where you set your profile picture and manage security, payments, notifications and more."
        )}
        contentClassName="text-center"
        actionsClassName="pt-6"
      >
        <button
          type="button"
          className={cn(
            BASIC_DIALOG_ACTION_CLASS,
            BASIC_DIALOG_SECONDARY_ACTION_CLASS
          )}
          onClick={onClose}
        >
          {t("settings.welcome.action", "Got it")}
        </button>
      </BasicDialogFrame>
    </div>
  );
}
